import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { AssessmentSpotlight } from '../components/AssessmentSpotlight';
import { WelcomeVideo } from '../components/WelcomeVideo';
import { Paths } from '../components/Paths';
import { Familiar } from '../components/Familiar';
import { Speaking } from '../components/Speaking';
import { Newsletter } from '../components/Newsletter';
import { Footer } from '../components/Footer';
import { useScreenInit } from '../useScreenInit';
export function Home() {
  useScreenInit();
  return <div className="min-h-screen flex flex-col" data-id="element-203" data-mp="24ivbheiqctch">
      <Navbar data-id="element-204" data-mp="29f264b5oeif4" />
      <main className="flex-grow" data-id="element-205" data-mp="29ek4ez08vbzt">
        <Hero data-id="element-206" data-mp="2dhqiutxig9hd" />
        <AssessmentSpotlight data-id="element-207" data-mp="2dhgu19o7c8d9" />
        <Paths data-id="element-208" data-mp="2dirxf8dqje3u" />
        <WelcomeVideo data-id="element-209" data-mp="2dj9yqjf98iim" />
        <Familiar data-id="element-210" data-mp="2dfdrxr9ryos6" />
        <Speaking data-id="element-211" data-mp="3kvk5aj0nqz5g" />
        <Newsletter data-id="element-212" data-mp="3kw1xn4k78t83" />
      </main>
      <Footer data-id="element-213" data-mp="3kuqzbk9iwdod" />
    </div>;
}